export function alertMessage(message: string) {
  alert(message);
}
